/* global axios */
import ApiClient from '../ApiClient';

class MyAiTools extends ApiClient {
  constructor() {
    super('my_ai/assistants/tools', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }
}

export default new MyAiTools();
